// An out dated explanation of the Recipe Maker algorithm is available here:
// https://docs.google.com/document/d/1MWnx9-FPMCvEeIpvQkY6hjOP5o6Kngb7QaVHlBPZOsM/edit?usp=sharing
// Follow the instructions to request access, if necessary.

import { cloneDeep, reduce, filter, max, min, isArray } from 'lodash';

export default {
    unit_conversion: {
        "t": "5",
        "tsp": "5",
        "teaspoon": "5",
        "T": "15",
        "tablespoon": "15",
        "oz": "30",
        "floz": "30",
        "ounces": "30",
        "c": "240",
        "cp": "240",
        "cup": "240",
        "lb": "460",
        "pounds": "460",
        "pint": "480",
        "pt": "480",
        "quart": "960",
        "qt": "960",
        "gallon": "3840",
        "gal": "3840",
        "item": "120",
        "1 slice of bread": "28.35",
        "1 slice of cake": "56",
        "1 slice of pie": "56",
        "piece": "30",
        "dash": "0.625",
        "spiral serving": "rm_serving_size",
        "g": "1",
    },
    displayconvert: {
        "t": "teaspoon",
        "tsp": "teaspoon",
        "teaspoon": "teaspoon",
        "T": "tablespoon",
        "tablespoon": "tablespoon",
        "oz": "ounces",
        "floz": "ounces",
        "ounces": "ounces",
        "c": "cups",
        "cp": "cups",
        "cup": "cups",
        "lb": "pounds",
        "pounds": "pounds",
        "pint": "pints",
        "pt": "pints",
        "quart": "quarts",
        "qt": "quarts",
        "gallon": "gallons",
        "gal": "gallons",
        "item": "items",
        "1 slice of bread": "slices",
        "1 slice of cake": "slices",
        "1 slice of pie": "slices",
        "piece": "pieces",
        "dash": "dash",
        "spiral serving": "grams",
        "grams": "grams",
        "g": "grams",
    },
    calculate_recipe_ccfs: function(recipe_data) {

        console.log("\n\n========= CCFS : Begin ==============");
        // !! ccfs
        let calc_vars = {};
        calc_vars['fs'] = 'ccfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_carb_recipe'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['sum_fat_count'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_ccfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_ccfs calc_vars base');

        // !! 1st pass
        this.log('1st pass', 'calculate_recipe_ccfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {

            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_ccfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)

            // !! IMPORTANT everytime we make changes for color calculations diabetes is applied healthy diabeties and carb counting
            this.log([{
                'color_rm_g_r': calc_vars['color_rm_g_r'],
                'color_rm_g_y': calc_vars['color_rm_g_y'],
                'color_rm_g_g': calc_vars['color_rm_g_g']
            }], 'Colors Before');
            if (e.name.includes('#')) { // nuts are worth 1/5th the weight
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Nut # Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (parseFloat(e.rec_quantity_rm) / 5); }

                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm + (rec_quantity_rm /5)  [' + e.rec_quantity_rm + ']');
            } else if (e.name.toLowerCase().includes('sugar')) {
                // if (e.color == 'R') {
                //     calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'Y') {
                //     calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'G') {
                //     calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            } else {
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
            }

            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);
            e['carb_recipe'] = e['est_num_serv'] * parseFloat(e.carb_serving);
            e['cal_serv'] = parseFloat(e.cal_serving) * e['est_num_serv'];
            e['carb_serv'] = parseFloat(e.carb_serving) * e['est_num_serv'];

            e['fat_serv'] = parseFloat(e.fat_serving) * e['est_num_serv'];
            for (let i = 0; i < e.categories.length; i++) {
                const ele = e.categories[i];
                if (ele.category == 'Fats') {
                    if (e.color == 'G') {
                        calc_vars['sum_fat_count'] += (e['fat_serv'] / 2);
                    } else {
                        calc_vars['sum_fat_count'] += e['fat_serv'];
                    }
                    break;
                }
            }

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math


            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];

            e['cal_recipe'] = e['cal_serv'] / recipe_data['servings'];
            calc_vars['sum_cal_recipe'] += e['cal_serv'];

            // e['carb_recipe'] = e['carb_serv'] / recipe_data['servings'];
            calc_vars['sum_carb_recipe'] += e['carb_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];

        }

        this.log(recipe_data, 'calculate_recipe_ccfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_ccfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_ccfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_ccfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;

            e['factor_weighted_avg'] = e['percent_decimal'] * e['carb_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_ccfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_ccfs calc_vars');
        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_ccfs');
        calc_vars['carb_serv_average'] = calc_vars['sum_carb_recipe'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }


        // new logic for colors for (ccfs, dfs, hfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }

        calc_vars['factor_recipe'] = 'x'
        if (calc_vars['carb_serv_average'] < 157.6) { calc_vars['factor_recipe'] = '10'; }
        if (calc_vars['carb_serv_average'] < 142.6) { calc_vars['factor_recipe'] = '9'; }
        if (calc_vars['carb_serv_average'] < 127.6) { calc_vars['factor_recipe'] = '8'; }
        if (calc_vars['carb_serv_average'] < 112.6) { calc_vars['factor_recipe'] = '7'; }
        if (calc_vars['carb_serv_average'] < 97.6) { calc_vars['factor_recipe'] = '6'; }
        if (calc_vars['carb_serv_average'] < 82.6) { calc_vars['factor_recipe'] = '5'; }
        if (calc_vars['carb_serv_average'] < 67.6) { calc_vars['factor_recipe'] = '4'; }
        if (calc_vars['carb_serv_average'] < 52.6) { calc_vars['factor_recipe'] = '3'; }
        if (calc_vars['carb_serv_average'] < 37.6) { calc_vars['factor_recipe'] = '2'; }
        if (calc_vars['carb_serv_average'] < 21.6) { calc_vars['factor_recipe'] = '1'; }
        if (calc_vars['carb_serv_average'] < 6.6) { calc_vars['factor_recipe'] = '0'; }

        // patch for extreme outliers
        if (calc_vars['factor_recipe'] == 'x') {
            calc_vars['factor_recipe'] = calc_vars['carb_serv_average'] / 15.5;
        }

        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];

        calc_vars['factor_recipe'] = this.round_factor_recipe_maker(calc_vars['factor_recipe']);

        this.log(recipe_data, 'calculate_recipe_ccfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_ccfs calc_vars');
        return calc_vars;


    },


    calculate_recipe_hfs: function(recipe_data) {
        console.log("\n\n========= HFS : Begin ==============");
        // !! hfs
        let calc_vars = {};
        calc_vars['fs'] = 'hfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_fiber_recipe'] = 0;
        calc_vars['sum_factor_recipe'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['sum_fat_count'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_hfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_hfs calc_vars base');

        // !! 1st pass
        this.log('calculate_recipe_hfs: 1st pass');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_hfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)

            // !! IMPORTANT everytime we make changes for color calculations diabetes is applied healthy diabeties and carb counting
            this.log([{
                'color_rm_g_r': calc_vars['color_rm_g_r'],
                'color_rm_g_y': calc_vars['color_rm_g_y'],
                'color_rm_g_g': calc_vars['color_rm_g_g']
            }], 'Colors Before');
            if (e.name.includes('#')) { // nuts are worth 1/5th the weight
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Nut # Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (parseFloat(e.rec_quantity_rm) / 5); }

                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm + (rec_quantity_rm /5)  [' + e.rec_quantity_rm + ']');
            } else if (e.name.toLowerCase().includes('sugar')) {
                // if (e.color == 'R') {
                //     calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'Y') {
                //     calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'G') {
                //     calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            } else {
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
            }

            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);
            e['factor'] = parseFloat(e.factor);
            if (isNaN(e['factor']) || e['factor'].trim == '') { e['factor'] = 0; }
            e['factor_recipe'] = e['est_num_serv'] * parseFloat(e.factor);
            calc_vars['sum_factor_recipe'] += e['factor_recipe'];

            e['cal_serv'] = parseFloat(e.cal_serving) * e['est_num_serv'];
            e['fiber_serv'] = parseFloat(e.fiber_serving) * e['est_num_serv'];

            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];


            e['fat_serv'] = parseFloat(e.fat_serving) * e['est_num_serv'];
            for (let i = 0; i < e.categories.length; i++) {
                const ele = e.categories[i];
                if (ele.category == 'Fats') {
                    if (e.color == 'G') {
                        calc_vars['sum_fat_count'] += (e['fat_serv'] / 2);
                    } else {
                        calc_vars['sum_fat_count'] += e['fat_serv'];
                    }
                    break;
                }
            }

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math

            e['cal_recipe'] = e['cal_serv'] / recipe_data['servings'];
            calc_vars['sum_cal_recipe'] += e['cal_serv'];

            e['fiber_recipe'] = e['fiber_serv'] / recipe_data['servings'];
            calc_vars['sum_fiber_recipe'] += e['fiber_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];


        }

        this.log(recipe_data, 'calculate_recipe_hfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_hfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_hfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_hfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;

            e['factor_weighted_avg'] = e['percent_decimal'] * e['factor_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_hfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_hfs calc_vars');

        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_hfs');
        calc_vars['factor_serv_average'] = calc_vars['sum_factor_weighted_avg'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }


        // new logic for colors for (ccfs, dfs, hfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }


        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];


        // calc_vars['sum_factor_recipe'] = this.round_factor_recipe_maker(calc_vars['sum_factor_recipe']);
        calc_vars['sum_factor_individual'] = this.round_factor_recipe_maker(calc_vars['sum_factor_recipe'] / recipe_data['servings']);

        this.log(recipe_data, 'calculate_recipe_hfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_hfs calc_vars');
        return calc_vars;

    },


    calculate_recipe_lsfs: function(recipe_data) {
        console.log("\n\n========= LSFS : Begin ==============");
        // !! lsfs
        let calc_vars = {};
        calc_vars['fs'] = 'lsfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_factor_recipe'] = 0;
        calc_vars['sum_na_recipe'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['sum_na_serv'] = 0;
        calc_vars['sum_na_serv_single'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_lsfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_lsfs calc_vars base');

        // !! 1st pass
        this.log('1st pass', 'calculate_recipe_lsfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_lsfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                this.log([e.name, i, e], 'water (cooked out), ignoring and moving to next ingredient');
                continue;
            }

            // this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)

            this.log([{
                'color_rm_g_r': calc_vars['color_rm_g_r'],
                'color_rm_g_y': calc_vars['color_rm_g_y'],
                'color_rm_g_g': calc_vars['color_rm_g_g']
            }], 'Colors Before');
            if (e.name.includes('*') || e.sid == '14715f323893845f8761') { // salts
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Salt Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm + (na_serving * 3ish)  [' + e.rec_quantity_rm + ']');
            } else {
                // new logic for colors for (lsfs rfs rdfs)
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (e.rec_quantity_rm); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (e.rec_quantity_rm); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (e.rec_quantity_rm); }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            }

            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);

            e['factor_recipe'] = e['est_num_serv'] * parseFloat(e.na_serving);
            calc_vars['sum_factor_recipe'] += e['factor_recipe'];


            e['cal_serv'] = parseFloat(e.cal_serving) * e['est_num_serv'];
            e['na_serv'] = parseFloat(e.na_serving) * e['est_num_serv'];
            calc_vars['sum_na_serv_single'] += parseFloat(e.na_serving);

            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math

            e['cal_recipe'] = e['cal_serv'] / recipe_data['servings'];
            calc_vars['sum_cal_recipe'] += e['cal_serv'];

            e['na_recipe'] = e['na_serv'] / recipe_data['servings'];
            calc_vars['sum_na_recipe'] += e['na_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];
        }

        this.log(recipe_data, 'calculate_recipe_lsfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_lsfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_lsfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_lsfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                this.log([e.name, i, e], 'water (cooked out), ignoring and moving to next ingredient');
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;

            e['factor_weighted_avg'] = e['percent_decimal'] * e['factor_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_lsfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_lsfs calc_vars');
        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_lsfs');
        calc_vars['factor_serv_average'] = calc_vars['sum_na_recipe'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }


        // new logic for colors for (lsfs rfs rdfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }

        calc_vars['factor_recipe'] = 'x'
        calc_vars['factor_recipe'] = Math.ceil((calc_vars['factor_serv_average'] - 56) / 100);
        if (calc_vars['factor_serv_average'] < 2056) { calc_vars['factor_recipe'] = '20'; }
        if (calc_vars['factor_serv_average'] < 1956) { calc_vars['factor_recipe'] = '19'; }
        if (calc_vars['factor_serv_average'] < 1856) { calc_vars['factor_recipe'] = '18'; }
        if (calc_vars['factor_serv_average'] < 1756) { calc_vars['factor_recipe'] = '17'; }
        if (calc_vars['factor_serv_average'] < 1656) { calc_vars['factor_recipe'] = '16'; }
        if (calc_vars['factor_serv_average'] < 1556) { calc_vars['factor_recipe'] = '15'; }
        if (calc_vars['factor_serv_average'] < 1456) { calc_vars['factor_recipe'] = '14'; }
        if (calc_vars['factor_serv_average'] < 1356) { calc_vars['factor_recipe'] = '13'; }
        if (calc_vars['factor_serv_average'] < 1256) { calc_vars['factor_recipe'] = '12'; }
        if (calc_vars['factor_serv_average'] < 1156) { calc_vars['factor_recipe'] = '11'; }
        if (calc_vars['factor_serv_average'] < 1056) { calc_vars['factor_recipe'] = '10'; }
        if (calc_vars['factor_serv_average'] < 956) { calc_vars['factor_recipe'] = '9'; }
        if (calc_vars['factor_serv_average'] < 856) { calc_vars['factor_recipe'] = '8'; }
        if (calc_vars['factor_serv_average'] < 756) { calc_vars['factor_recipe'] = '7'; }
        if (calc_vars['factor_serv_average'] < 656) { calc_vars['factor_recipe'] = '6'; }
        if (calc_vars['factor_serv_average'] < 556) { calc_vars['factor_recipe'] = '5'; }
        if (calc_vars['factor_serv_average'] < 456) { calc_vars['factor_recipe'] = '4'; }
        if (calc_vars['factor_serv_average'] < 356) { calc_vars['factor_recipe'] = '3'; }
        if (calc_vars['factor_serv_average'] < 256) { calc_vars['factor_recipe'] = '2'; }
        if (calc_vars['factor_serv_average'] < 130) { calc_vars['factor_recipe'] = '1'; }
        if (calc_vars['factor_serv_average'] < 51) { calc_vars['factor_recipe'] = '0'; }

        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];

        calc_vars['factor_recipe'] = this.round_factor_recipe_maker(calc_vars['factor_recipe']);



        // if (calc_vars['factor_recipe'] == 0) {
        //   calc_vars['color_recipe'] = 'G';
        // }

        this.log(recipe_data, 'calculate_recipe_lsfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_lsfs calc_vars');

        return calc_vars;

    },



    calculate_recipe_dfs: function(recipe_data) {
        console.log("\n\n========= DFS : Begin ==============");
        // !! dfs
        let calc_vars = {};
        calc_vars['fs'] = 'dfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_factor_recipe'] = 0;
        calc_vars['sum_fiber_recipe'] = 0;
        calc_vars['sum_factor_weighted_value'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['sum_fat_count'] = 0;
        calc_vars['sum_na_serv'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_dfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_dfs calc_vars base');

        // !! 1st pass
        this.log('1st pass', 'calculate_recipe_dfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_dfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                this.log([e.name, i, e], 'water (cooked out), ignoring and moving to next ingredient');
                continue;
            }

            this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)

            // !! IMPORTANT everytime we make changes for color calculations diabetes is applied healthy diabeties and carb counting
            this.log([{
                'color_rm_g_r': calc_vars['color_rm_g_r'],
                'color_rm_g_y': calc_vars['color_rm_g_y'],
                'color_rm_g_g': calc_vars['color_rm_g_g']
            }], 'Colors Before');
            if (e.name.includes('#')) { // nuts are worth 1/5th the weight
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Nut # Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (parseFloat(e.rec_quantity_rm) / 5); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (parseFloat(e.rec_quantity_rm) / 5); }

                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm + (rec_quantity_rm /5)  [' + e.rec_quantity_rm + ']');
            } else if (e.name.toLowerCase().includes('sugar')) {

                // if (e.color == 'R') {
                //     calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'Y') {
                //     calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'G') {
                //     calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            } else {
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            }

            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);

            e['factor_recipe'] = e['est_num_serv'] * parseFloat(e.cal_serving);
            calc_vars['sum_factor_recipe'] += e['factor_recipe'];


            e['cal_serv'] = parseFloat(e.cal_serving) * e['est_num_serv'];
            e['fiber_serv'] = parseFloat(e.fiber_serving) * e['est_num_serv'];

            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];


            e['fat_serv'] = parseFloat(e.fat_serving) * e['est_num_serv'];
            for (let i = 0; i < e.categories.length; i++) {
                const ele = e.categories[i];
                if (ele.category == 'Fats') {
                    if (e.color == 'G') {
                        calc_vars['sum_fat_count'] += (e['fat_serv'] / 2);
                    } else {
                        calc_vars['sum_fat_count'] += e['fat_serv'];
                    }
                    break;
                }
            }

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math

            e['cal_recipe'] = e['cal_serv'] / recipe_data['servings'];
            calc_vars['sum_cal_recipe'] += e['cal_serv'];

            e['fiber_recipe'] = e['fiber_serv'] / recipe_data['servings'];
            calc_vars['sum_fiber_recipe'] += e['fiber_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];
        }

        this.log(recipe_data, 'calculate_recipe_dfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_dfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_dfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_dfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;

            e['factor_weighted_avg'] = e['percent_decimal'] * e['factor_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_dfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_dfs calc_vars');
        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_dfs');
        calc_vars['factor_serv_average'] = calc_vars['sum_cal_recipe'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }

        // new logic for colors for (ccfs, dfs, hfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }


        calc_vars['factor_recipe'] = 'x'

        calc_vars['factor_recipe'] = Math.ceil((calc_vars['factor_serv_average'] - 51) / 100);
        if (calc_vars['factor_serv_average'] < 2051) { calc_vars['factor_recipe'] = '20'; }
        if (calc_vars['factor_serv_average'] < 1951) { calc_vars['factor_recipe'] = '19'; }
        if (calc_vars['factor_serv_average'] < 1851) { calc_vars['factor_recipe'] = '18'; }
        if (calc_vars['factor_serv_average'] < 1751) { calc_vars['factor_recipe'] = '17'; }
        if (calc_vars['factor_serv_average'] < 1651) { calc_vars['factor_recipe'] = '16'; }
        if (calc_vars['factor_serv_average'] < 1551) { calc_vars['factor_recipe'] = '15'; }
        if (calc_vars['factor_serv_average'] < 1451) { calc_vars['factor_recipe'] = '14'; }
        if (calc_vars['factor_serv_average'] < 1351) { calc_vars['factor_recipe'] = '13'; }
        if (calc_vars['factor_serv_average'] < 1251) { calc_vars['factor_recipe'] = '12'; }
        if (calc_vars['factor_serv_average'] < 1151) { calc_vars['factor_recipe'] = '11'; }
        if (calc_vars['factor_serv_average'] < 1051) { calc_vars['factor_recipe'] = '10'; }
        if (calc_vars['factor_serv_average'] < 951) { calc_vars['factor_recipe'] = '9'; }
        if (calc_vars['factor_serv_average'] < 851) { calc_vars['factor_recipe'] = '8'; }
        if (calc_vars['factor_serv_average'] < 751) { calc_vars['factor_recipe'] = '7'; }
        if (calc_vars['factor_serv_average'] < 651) { calc_vars['factor_recipe'] = '6'; }
        if (calc_vars['factor_serv_average'] < 551) { calc_vars['factor_recipe'] = '5'; }
        if (calc_vars['factor_serv_average'] < 451) { calc_vars['factor_recipe'] = '4'; }
        if (calc_vars['factor_serv_average'] < 351) { calc_vars['factor_recipe'] = '3'; }
        if (calc_vars['factor_serv_average'] < 201) { calc_vars['factor_recipe'] = '2'; }
        if (calc_vars['factor_serv_average'] < 71) { calc_vars['factor_recipe'] = '1'; }
        if (calc_vars['factor_serv_average'] < 20) { calc_vars['factor_recipe'] = '0'; }


        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];

        calc_vars['factor_recipe'] = this.round_factor_recipe_maker(calc_vars['factor_recipe']);



        this.log(recipe_data, 'calculate_recipe_dfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_dfs calc_vars');
        return calc_vars;

    },


    calculate_recipe_rfs: function(recipe_data) {
        console.log("\n\n========= RFS : Begin ==============");
        // !! rfs
        let calc_vars = {};
        calc_vars['fs'] = 'rfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_cal_serv'] = 0;
        calc_vars['sum_factor_recipe'] = 0;
        calc_vars['sum_fiber_recipe'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['sum_factor_weighted_value'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['sum_na_serv'] = 0;
        calc_vars['sum_k_serv'] = 0;
        calc_vars['sum_p_serv'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_rfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_rfs calc_vars base');

        // !! 1st pass
        this.log('1st pass', 'calculate_recipe_rfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_rfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            // this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)


            if (e.name.includes('*') || e.sid == '14715f323893845f8761') { // salts
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Salt Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3)); }
            } else {
                // new logic for colors for (lsfs rfs rdfs)
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (e.rec_quantity_rm); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (e.rec_quantity_rm); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (e.rec_quantity_rm); }
            }

            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);
            e['factor'] = parseFloat(e.factor);
            if (isNaN(e['factor']) || e['factor'].trim == '') { e['factor'] = 0; }
            e['factor_recipe'] = e['est_num_serv'] * parseFloat(e.factor);
            calc_vars['sum_factor_recipe'] += e['factor_recipe'];




            e['na_recipe'] = parseFloat(e.na_serving) * e['est_num_serv'];
            e['k_recipe'] = parseFloat(e.k_serving) * e['est_num_serv'];
            e['p_recipe'] = parseFloat(e.p_serving) * e['est_num_serv'];
            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];
            e['cal_recipe'] = parseFloat(e.cal_serving) * e['est_num_serv'];

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math

            e['na_serv'] = e['na_recipe'] / recipe_data['servings'];
            calc_vars['sum_na_serv'] += e['na_serv'];

            e['k_serv'] = e['k_recipe'] / recipe_data['servings'];
            calc_vars['sum_k_serv'] += e['k_serv'];

            e['p_serv'] = e['p_recipe'] / recipe_data['servings'];
            calc_vars['sum_p_serv'] += e['p_serv'];

            e['cal_serv'] = e['cal_recipe'] / recipe_data['servings'];
            calc_vars['sum_cal_serv'] += e['cal_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];



        }

        this.log(recipe_data, 'calculate_recipe_rfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_rfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_rfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;


            e['factor_weighted_avg'] = e['percent_decimal'] * e['factor_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_rfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rfs calc_vars');
        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_rfs');
        calc_vars['factor_serv_average'] = calc_vars['sum_factor_recipe'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }

        // highest value
        calc_vars['highest_is_p'] = false;
        calc_vars['highest'] = calc_vars['sum_p_serv'];
        if (calc_vars['sum_na_serv'] > calc_vars['sum_k_serv'] && calc_vars['sum_na_serv'] > calc_vars['sum_p_serv']) {
            calc_vars['highest'] = calc_vars['sum_na_serv'];
        }
        if (calc_vars['sum_k_serv'] > calc_vars['sum_na_serv'] && calc_vars['sum_k_serv'] > calc_vars['sum_p_serv']) {
            calc_vars['highest'] = calc_vars['sum_k_serv'];
        }
        if (calc_vars['sum_p_serv'] > calc_vars['sum_na_serv'] && calc_vars['sum_p_serv'] > calc_vars['sum_k_serv']) {
            calc_vars['highest'] = calc_vars['sum_p_serv'];
            calc_vars['highest_is_p'] = true;
        }


        // new logic for colors for (lsfs rfs rdfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }


        calc_vars['factor_recipe'] = 'x'

        calc_vars['highest_factor_divisor'] = 1;
        if (calc_vars['highest_is_p']) {
            calc_vars['highest_factor_divisor'] = 2;
        }

        calc_vars['factor_recipe'] = Math.ceil(((calc_vars['highest'] * calc_vars['highest_factor_divisor']) - 1) / 100);
        if (calc_vars['highest'] < 2001 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '20'; }
        if (calc_vars['highest'] < 1901 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '19'; }
        if (calc_vars['highest'] < 1801 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '18'; }
        if (calc_vars['highest'] < 1701 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '17'; }
        if (calc_vars['highest'] < 1601 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '16'; }
        if (calc_vars['highest'] < 1501 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '15'; }
        if (calc_vars['highest'] < 1401 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '14'; }
        if (calc_vars['highest'] < 1301 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '13'; }
        if (calc_vars['highest'] < 1201 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '12'; }
        if (calc_vars['highest'] < 1101 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '11'; }
        if (calc_vars['highest'] < 1001 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '10'; }
        if (calc_vars['highest'] < 901 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '9'; }
        if (calc_vars['highest'] < 801 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '8'; }
        if (calc_vars['highest'] < 701 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '7'; }
        if (calc_vars['highest'] < 601 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '6'; }
        if (calc_vars['highest'] < 501 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '5'; }
        if (calc_vars['highest'] < 401 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '4'; }
        if (calc_vars['highest'] < 301 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '3'; }
        if (calc_vars['highest'] < 121 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '2'; }
        if (calc_vars['highest'] < 61 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '1'; }
        if (calc_vars['highest'] < 36 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '0'; }

        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];

        calc_vars['factor_recipe'] = this.round_factor_recipe_maker(calc_vars['factor_recipe']);

        this.log(recipe_data, 'calculate_recipe_rfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rfs calc_vars');
        return calc_vars;

    },


    calculate_recipe_rdfs: function(recipe_data, rfs_calcs, dfs_calcs) {

        // Renal Diabetes FOOD SPIRAL Changes for COLOR only:
        // Do the highest level.
        // Example if the Renal FS is Green and the Diabetes FS is Yellow the color for the RDFS is Yellow. If the Renal is Red and the Diabetes is Green, the color for RDFS is Red.  You use the highest color of both FOOD SPIRALs.
        console.log("\n\n========= RDFS : Begin ==============\n");
        this.log('RDFS Begin', 'calculate_recipe_rdfs');

        // !! rdfs
        let calc_vars = {};
        calc_vars['fs'] = 'rdfs';
        calc_vars['out'] = [];
        calc_vars['sum_rec_quantity_rm'] = 0;
        calc_vars['sum_cal_recipe'] = 0;
        calc_vars['sum_cal_serv'] = 0;
        calc_vars['sum_factor_recipe'] = 0;
        calc_vars['sum_fiber_recipe'] = 0;
        calc_vars['sum_factor_weighted_avg'] = 0;
        calc_vars['sum_factor_weighted_value'] = 0;
        calc_vars['color_rm_g_r'] = 0;
        calc_vars['color_rm_g_y'] = 0;
        calc_vars['color_rm_g_g'] = 0;
        calc_vars['sum_na_serv'] = 0;
        calc_vars['sum_k_serv'] = 0;
        calc_vars['sum_p_serv'] = 0;
        calc_vars['sum_fat_serv'] = 0;
        calc_vars['sum_fiber_serv'] = 0;
        calc_vars['sum_fluid_serv'] = 0;
        calc_vars['errors'] = [];

        this.log(recipe_data, 'calculate_recipe_rdfs recipe_data base');
        this.log(calc_vars, 'calculate_recipe_rdfs calc_vars base');

        // !! 1st pass
        this.log('1st pass', 'calculate_recipe_rdfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_rdfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            // this.ingredient_calcs.process_red_fats_and_meats(calc_vars, e);

            calc_vars['sum_rec_quantity_rm'] += e.rec_quantity_rm; // Amount (g)


            if (e.name.includes('^')) {
                console.log('Found New Multiplier for RDFS with ingredient: ' + e.name);
                if (e.color == 'R') {
                    calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 4));
                }
                if (e.color == 'Y') {
                    calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 4));
                }
                if (e.color == 'G') {
                    calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 4));
                }
            }

            if (e.name.includes('*') || e.sid == '14715f323893845f8761') { // salts
                // new logic for colors for (lsfs rfs rdfs)
                console.log('Found Salt Multiplier for color_rm_g_r: ' + e.name);
                if (e.color == 'R') {
                    calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3));
                }
                if (e.color == 'Y') {
                    calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3));
                }
                if (e.color == 'G') {
                    calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + ((parseFloat(e.na_serving) + 0.1) * 3));
                }
            } else if (e.name.toLowerCase().includes('sugar')) {
                // if (e.color == 'R') {
                //     calc_vars['color_rm_g_r'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'Y') {
                //     calc_vars['color_rm_g_y'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                // if (e.color == 'G') {
                //     calc_vars['color_rm_g_g'] += (e.rec_quantity_rm + (parseFloat(e.na_serving) * 2));
                // }
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += e.rec_quantity_rm; }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += e.rec_quantity_rm; }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += e.rec_quantity_rm; }
                this.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After += rec_quantity_rm [' + e.rec_quantity_rm + ']');
            } else {
                // new logic for colors for (lsfs rfs rdfs)
                if (e.color == 'R') { calc_vars['color_rm_g_r'] += (e.rec_quantity_rm); }
                if (e.color == 'Y') { calc_vars['color_rm_g_y'] += (e.rec_quantity_rm); }
                if (e.color == 'G') { calc_vars['color_rm_g_g'] += (e.rec_quantity_rm); }
            }



            e['est_num_serv'] = parseFloat(e.rec_quantity_rm) / parseFloat(e.rm_serving_size);
            e['factor'] = parseFloat(e.factor);
            if (isNaN(e['factor']) || e['factor'].trim == '') { e['factor'] = 0; }
            e['factor_recipe'] = e['est_num_serv'] * parseFloat(e.factor);
            calc_vars['sum_factor_recipe'] += e['factor_recipe'];


            e['na_recipe'] = parseFloat(e.na_serving) * e['est_num_serv'];
            e['k_recipe'] = parseFloat(e.k_serving) * e['est_num_serv'];
            e['p_recipe'] = parseFloat(e.p_serving) * e['est_num_serv'];
            e['fluid_recipe'] = parseFloat(e.fluids);
            if (isNaN(e['fluid_recipe'])) { e['fluid_recipe'] = 0; }
            e['fluid_recipe'] = e['fluid_recipe'] * e['est_num_serv'];
            e['cal_recipe'] = parseFloat(e.cal_serving) * e['est_num_serv'];
            e['fat_recipe'] = parseFloat(e.fat_serving) * e['est_num_serv'];
            e['fiber_recipe'] = parseFloat(e.fiber_serving) * e['est_num_serv'];

            recipe_data['servings'] = parseFloat(recipe_data['servings']); // float point math

            e['na_serv'] = e['na_recipe'] / recipe_data['servings'];
            calc_vars['sum_na_serv'] += e['na_serv'];

            e['k_serv'] = e['k_recipe'] / recipe_data['servings'];
            calc_vars['sum_k_serv'] += e['k_serv'];

            e['p_serv'] = e['p_recipe'] / recipe_data['servings'];
            calc_vars['sum_p_serv'] += e['p_serv'];

            e['cal_serv'] = e['cal_recipe'] / recipe_data['servings'];
            calc_vars['sum_cal_serv'] += e['cal_serv'];

            e['fat_serv'] = e['fat_recipe'] / recipe_data['servings'];
            calc_vars['sum_fat_serv'] += e['fat_serv'];

            e['fiber_serv'] = e['fiber_recipe'] / recipe_data['servings'];
            calc_vars['sum_fiber_serv'] += e['fiber_serv'];

            e['fluid_serv'] = e['fluid_recipe'] / recipe_data['servings'];
            calc_vars['sum_fluid_serv'] += e['fluid_serv'];


        }

        this.log(recipe_data, 'calculate_recipe_rdfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rdfs calc_vars');
        // !! 2nd pass
        this.log('2nd pass, sums', 'calculate_recipe_rdfs');
        for (let i = 0; i < recipe_data['ingredients'].length; i++) {
            let e = recipe_data['ingredients'][i];
            this.log([e.name, i, e], 'calculate_recipe_rdfs ingredients');

            if (e.name === 'Water (Cooked Out)') {
                continue;
            }

            e['percent_decimal'] = (e.rec_quantity_rm / calc_vars['sum_rec_quantity_rm']);
            e['percent'] = e['percent_decimal'] * 100;


            e['factor_weighted_avg'] = e['percent_decimal'] * e['factor_recipe'];
            calc_vars['sum_factor_weighted_avg'] += e['factor_weighted_avg'];
        }

        this.log(recipe_data, 'calculate_recipe_rdfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rdfs calc_vars');
        // !! 3rd pass
        this.log('3rd pass, totals', 'calculate_recipe_rdfs');
        calc_vars['factor_serv_average'] = calc_vars['sum_factor_recipe'] / recipe_data['servings'];

        // if (calc_vars['color_rm_g_y'] == 0) {
        //     calc_vars['color_rm_g_y'] = (calc_vars['color_rm_g_r'] + calc_vars['color_rm_g_g']) / 2;
        // }

        // highest value
        calc_vars['highest_is_p'] = false;
        calc_vars['highest'] = calc_vars['sum_p_serv'];
        if (calc_vars['sum_na_serv'] > calc_vars['sum_k_serv'] && calc_vars['sum_na_serv'] > calc_vars['sum_p_serv']) {
            calc_vars['highest'] = calc_vars['sum_na_serv'];
        }
        if (calc_vars['sum_k_serv'] > calc_vars['sum_na_serv'] && calc_vars['sum_k_serv'] > calc_vars['sum_p_serv']) {
            calc_vars['highest'] = calc_vars['sum_k_serv'];
        }
        if (calc_vars['sum_p_serv'] > calc_vars['sum_na_serv'] && calc_vars['sum_p_serv'] > calc_vars['sum_k_serv']) {
            calc_vars['highest'] = calc_vars['sum_p_serv'];
            calc_vars['highest_is_p'] = true;
        }

        // new logic for colors for (lsfs rfs rdfs)
        if (
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_y'] &&
            calc_vars['color_rm_g_r'] > calc_vars['color_rm_g_g']
        ) {
            calc_vars['color_recipe'] = 'R';
        } else if (calc_vars['color_rm_g_y'] > calc_vars['color_rm_g_g']) {
            calc_vars['color_recipe'] = 'Y';
        } else {
            calc_vars['color_recipe'] = 'G';
        }

        const colorToNum = ['G', 'Y', 'R'];
        const dfs_color_num = colorToNum.indexOf(dfs_calcs['color_recipe']);
        const rfs_color_num = colorToNum.indexOf(rfs_calcs['color_recipe']);
        const color_num = colorToNum.indexOf(calc_vars['color_recipe']);

        calc_vars['color_recipe'] = colorToNum[Math.max(
            dfs_color_num,
            rfs_color_num,
            // color_num
        )];

        calc_vars['highest_factor_divisor'] = 1;
        if (calc_vars['highest_is_p']) {
            calc_vars['highest_factor_divisor'] = 2;
        }

        calc_vars['factor_recipe'] = 'x'
        calc_vars['factor_recipe'] = Math.ceil(((calc_vars['highest'] * calc_vars['highest_factor_divisor']) - 1) / 100);
        if (calc_vars['highest'] < 2001 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '20'; }
        if (calc_vars['highest'] < 1901 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '19'; }
        if (calc_vars['highest'] < 1801 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '18'; }
        if (calc_vars['highest'] < 1701 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '17'; }
        if (calc_vars['highest'] < 1601 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '16'; }
        if (calc_vars['highest'] < 1501 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '15'; }
        if (calc_vars['highest'] < 1401 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '14'; }
        if (calc_vars['highest'] < 1301 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '13'; }
        if (calc_vars['highest'] < 1201 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '12'; }
        if (calc_vars['highest'] < 1101 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '11'; }
        if (calc_vars['highest'] < 1001 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '10'; }
        if (calc_vars['highest'] < 901 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '9'; }
        if (calc_vars['highest'] < 801 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '8'; }
        if (calc_vars['highest'] < 701 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '7'; }
        if (calc_vars['highest'] < 601 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '6'; }
        if (calc_vars['highest'] < 501 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '5'; }
        if (calc_vars['highest'] < 401 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '4'; }
        if (calc_vars['highest'] < 301 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '3'; }
        if (calc_vars['highest'] < 121 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '2'; }
        if (calc_vars['highest'] < 61 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '1'; }
        if (calc_vars['highest'] < 36 / calc_vars['highest_factor_divisor']) { calc_vars['factor_recipe'] = '0'; }

        calc_vars['individual_serving_size'] = calc_vars['sum_rec_quantity_rm'] / recipe_data['servings'];

        calc_vars['factor_recipe'] = this.round_factor_recipe_maker(calc_vars['factor_recipe']);


        this.log(recipe_data, 'calculate_recipe_rdfs recipe_data');
        this.log(calc_vars, 'calculate_recipe_rdfs calc_vars');
        return calc_vars;

    },

    ingredient_calcs: {
        process_red_fats_and_meats: function(calc_vars, ingredient) {
            const ingredientCategoryNames = ingredient.categories.map(i => i.name);
            if (
                ingredient.color == 'R' &&
                (ingredientCategoryNames.includes('Fats') || ingredientCategoryNames.includes('Meats & Protein'))
            ) {
                console.log('Found Category Multiplier [process_red_fats_and_meats += (rec_quantity_rm * 4) ] for color_rm_g_r: ' + ingredient.name);
                console.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors Before');
                calc_vars['color_rm_g_r'] += ((ingredient.rec_quantity_rm * 4));
                console.log([{
                    'color_rm_g_r': calc_vars['color_rm_g_r'],
                    'color_rm_g_y': calc_vars['color_rm_g_y'],
                    'color_rm_g_g': calc_vars['color_rm_g_g']
                }], 'Colors After');
            }
        },
    },

    preprocess_zero_factor_ingredients: function(recipe_data, user_spiral_code) {
        // Note: this code is almost a replica of:
        //  \App\Http\Controllers\Api\FoodMealLogController::calculateZeroFactor

        let myRecipeData = cloneDeep(recipe_data);
        const table = this.zero_factor_conversion_table();

        const spiralNameConversion = {
            'hfs': 'healthy',
            'ccfs': 'carb-counting',
            'lsfs': 'low-sodium',
            'dfs': 'diabetes',
            'rfs': 'renal',
            'rdfs': 'renal-diabetes',
        }

        let spiral = spiralNameConversion[user_spiral_code] || user_spiral_code;

        for (const ingredient of myRecipeData.ingredients) {

            let factor = ingredient['factor'];
            let ingredientServings = parseFloat(ingredient.rec_quantity_rm) / parseFloat(ingredient.rm_serving_size);

            if (factor !== 0 && factor !== '0') {
                // Skip if this is not a zero-factor food
                continue;
            }

            // Only get the ingredients from the conversion table that applies to the user
            let filteredTable = filter(table, (tableElement) => {
                return tableElement.spirals.includes(spiral);
            });

            factor = reduce(filteredTable, (carry, tableElement) => {
                let newFactor = 0;
                let amount = ingredient[tableElement.column_name] * ingredientServings;

                // Convert the increments to an array, if they aren't
                let increments = Array.isArray(tableElement.increments) ?
                    tableElement.increments : [tableElement.increments];

                while (increments.length > 1) {
                    let increment = increments.shift();
                    let factorIncrease;
                    newFactor += factorIncrease = min([1, Math.floor(amount / increment)]);
                    amount -= factorIncrease * increment;
                }

                let increment = increments.shift();
                newFactor += Math.floor(amount / increment);

                return max([carry, newFactor])
            }, factor);

            ingredient['factor'] = factor;
        }

        return myRecipeData;
    },

    zero_factor_conversion_table: function() {
        // Note: this table is a duplicate of:
        //  \App\Http\Controllers\Api\FoodMealLogController::zeroFactorConversionTable
        return {
            'na': {
                'spirals': ['renal', 'renal-diabetes', 'low-sodium'],
                'column_name': 'na_serving',
                'increments': 100
            },
            'k': {
                'spirals': ['renal', 'renal-diabetes'],
                'column_name': 'k_serving',
                'increments': 100
            },
            'p': {
                'spirals': ['renal', 'renal-diabetes'],
                'column_name': 'p_serving',
                'increments': 50
            },
            'cal': {
                'spirals': ['healthy', 'diabetes'],
                'column_name': 'cal_serving',
                'increments': 100,
            },
            'carb': {
                'spirals': ['carb-counting'],
                'column_name': 'carb_serving',
                'increments': [6.6, 15],
            },
        };
    },

    round_factor_recipe_maker: function(factor) {
        // The rounding for recipe_maker is *not* the same as rounding for food search, food groups, etc.
        // Do not confuse `FoodCalculator.round_factor_recipe_maker` for `utils.round_factor`.
        // They are different on purpose. See tests for specific examples of each.
        return Math.round(factor);
    },

    grams_to_units: function(value, unit) {
        return value / Number(this.unit_conversion[unit]);
    },

    log_orig: function(obj, sPrefix = 'LOG') {
        console.log(sPrefix, JSON.parse(JSON.stringify(obj, function(k, v) { return v === undefined ? null : v; })));
    },

    log: function(objArray, sPrefix = 'LOG') {
        if (isArray(objArray)) {
            for (let i = 0; i < objArray.length; i++) {
                console.log(sPrefix + ' (' + this.ln() + ') ' + ' : ' + i, JSON.parse(JSON.stringify(objArray[i], function(k, v) { return v === undefined ? null : v; })));
            }
        } else {
            console.log(sPrefix + ' (' + this.ln() + ') ', JSON.parse(JSON.stringify(objArray, function(k, v) { return v === undefined ? null : v; })));
        }
    },

    ln: function() { // https://stackoverflow.com/a/27074218
        var e = new Error();
        if (!e.stack) try {
            // IE requires the Error to actually be throw or else the Error's 'stack'
            // property is undefined.
            throw e;
        } catch (e) {
            if (!e.stack) {
                return 0; // IE < 10, likely
            }
        }
        var stack = e.stack.toString().split(/\r\n|\n/);
        // We want our caller's frame. It's index into |stack| depends on the
        // browser and browser version, so we need to search for the second frame:
        var frameRE = /:(\d+):(?:\d+)[^\d]*$/;
        do {
            var frame = stack.shift();
        } while (!frameRE.exec(frame) && stack.length);
        return frameRE.exec(stack.shift())[1];
    }

}